import React, { useMemo, useEffect, useState } from "react";

import { connect } from "react-redux";

import { Icon } from "components/Icon";

import { withTranslation } from "hoc/WithTranslation";
import CheckboxControl from "components/Form/CheckboxControl";
import CustomField from "components/Form/CustomField";
import { str40 } from "components/Form/Text";

import TrafficLimitSection from "./TrafficLimitSection";
import IpListSection from "./IpListSection";
import IpWhiteListSection from "./IpWhiteListSection";
import ContentSupplierForm from "./ContentSupplierForm";
import NonDialerTrafficRoute from "./NonDialerTrafficRoute";
import {
    dayModel, hourModel, supplierIdModel, ipRegex, TRAFFIC_LIMIT_UNEDITABLE, applyValidationErrors, } from "./TrunkFormRefactored.utils";
import {
    StyledFlexboxGrid, StyledTwoColumnLayout, StyledLeftColumn, StyledRightColumn, StyledSingleLineFlexboxGridItem, Header, CustomPercentField, StyledMenuItem, } from "./TrunkFormRefactored.styles";

import { FlexboxGrid, Input, InputNumber, Schema, SelectPicker, Tooltip } from "rsuite";
import Whisper from "components/Whisper";
import Form from "components/Form/CompatForm";

const { StringType, NumberType } = Schema.Types;

const TrunkFormRefactored = ({
    disabled,
    updateFormRef,
    updateFormRef4,
    termPoint,
    initialValues,
    newTrunk,
    isMobile,
    error,
    setError,
    ipList = [],
    setIpList,
    httpIpList = [],
    setHttpIpList,
    isGanTrunks,
    isTransitTrunks,
    supplierPriceList,
    setMoreData,
    protocolType,
    setProtocolType,
    formTrafficLimitRef,
    trafficLimitKeyList,
    setTrafficLimitKeyList,
    paymentTermsList = [],
    rerouteStatusList = [],
    initTrafficLimitList,
    protocolTypeValues,
    hasAnyOrganic,
    setNonDialerValid,
    setNonDialerPartial,
    formatMessage
}) => {
    const formSmsSupplierModel = useMemo(() => {
        return Schema.Model({
            ...(isTransitTrunks ? {
                supplier_price_id: StringType()
                    .isRequired("Required")
            } : {}),
            dlr_percent: NumberType()
                .isInteger("Precent should be integer"),
            name: str40,
            ...(!protocolTypeValues.http ? {
                systemid: StringType()
                    .isRequired("Required")
                    .minLength(4, "The minimum is 4 characters.")
                    .maxLength(16, "The maximum is only 16 characters."),
                passwd: StringType()
                    .isRequired("Required")
                    .addRule((value) => {
                        const len = String(value).length;
                        return len >= 4 && len <= 9;
                    }, "Password length must be 4-9")
            } : {}),
            ...(!isTransitTrunks && paymentTermsList.length ? paymentTermsList.reduce((result, item) => {
                result[`discount_${item.name}`] = NumberType()
                    .isRequired("Required")
                    .min(0, "Minimum 0")
                    .max(100, "Maximum 100");
                return result;
            }, {}) : {}),
        });
    }, [isTransitTrunks, paymentTermsList, protocolTypeValues]);

    const formSupplierModel = useMemo(() => {
        return Schema.Model({
            ...(protocolTypeValues.smpp_mo ? {
                port: NumberType()
                    .isRequired("Required")
                    .range(0, 65535, "Enter the correct port"),
            } : {}),
            ip: StringType()
                .isRequired("Required")
                .pattern(
                    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
                    "Please enter legal IP Address"
                )
        });
    }, [protocolTypeValues]);

    const ipFormRef = {};

    const defaultFormValue = {
        active: true,
        smpp_reroute_status_key: 11,
        delivery_delay_type: 0,
        message_protocol: protocolType,

        ...initialValues,
        supplier_price_id: initialValues?.price ? initialValues.price.id : null,
        ...(initialValues?.discount_list ? initialValues.discount_list.reduce((result, item) => {
            result[`discount_${item.payment_terms_name}`] = item.discount * 100;
            return result;
        }, {}) : {}),
        termination_point: termPoint,
        dlr_percent: (!newTrunk ? initialValues?.dlr_percent || 0 : 0.97) * 100
    };

    const formContentModel = Schema.Model({
        postback_response_body: StringType()
    });

    const trafficLimitModel = isTransitTrunks
        ? Schema.Model.combine(dayModel, supplierIdModel)
        : Schema.Model.combine(dayModel, hourModel, supplierIdModel);

    const [acceptedTrafficLimitList, setAcceptedTrafficLimitList] = useState(trafficLimitKeyList);
    const [formState, setFormState] = useState(defaultFormValue);

    const defaultTrafficLimitKeyList = trafficLimitKeyList.reduce((result, trafficLimit) => {
        result[trafficLimit.key] = {
            ...trafficLimit,
            editing: TRAFFIC_LIMIT_UNEDITABLE
        };
        return result;
    }, {});

    const [trafficLimitEditData, setTrafficLimitEditData] = useState(defaultTrafficLimitKeyList);

    useEffect(() => {
        setTrafficLimitKeyList(initTrafficLimitList);
        setTrafficLimitEditData(defaultTrafficLimitKeyList || {});
        setHttpIpList(initialValues?.ip_white_list || []);
        setIpList(initialValues?.ip_list || []);
    }, [protocolType]);

    useEffect(() => {
        ipList.forEach(({ key }) => {
            ipFormRef[key] = {};
        });
    }, [ipList]);

    useEffect(() => {
        if (["smpp", "smpp_mo"].includes(protocolType)) {
            ipList.forEach(({ key }) => {
                if (Object.keys(ipFormRef[key]).length && !ipFormRef[key].check()) {
                    const errorFormValue = ipFormRef[key].getFormValue();

                    const checkedFormValue = formSupplierModel.check(errorFormValue);
                    applyValidationErrors(setError, "ipErrors", key, checkedFormValue);
                }
            });
        }
    }, [protocolType]);

    const renderMenuItem = (label, { global, name }) => {
        return (
            <StyledMenuItem global={global}>{name}</StyledMenuItem>
        );
    };

    const isOneOfSmpp = protocolTypeValues.smpp || protocolTypeValues.smpp_mo;

    const deliveryDelayTypeData = [
        { name: "No delay", value: 0 },
        { name: "Simulation of real delay", value: 1 },
        { name: "80% 2-6 seconds", value: 2 }
    ];

    const customRerouteStatusList = rerouteStatusList.map((value) => {
        return {
            name: `(${value.key}) ${value.smpp_reroute_status_name}`,
            key: value.key
        };
    });

    const [organicState, setOrganicState] = useState(() => ({ ...initialValues }));

    const isBillOnlyDeliveredDisabled = useMemo(() => {
        const v = organicState || {};
        return hasAnyOrganic(v) ||
            !!v.organic_use_ssl ||
            !!v.pass_all_traffic_to_organic;
    }, [organicState, initialValues]);

    const nonDialerTrafficRouteModel = useMemo(() => {
        return Schema.Model({
            organic_ip: StringType()
                .addRule((value, data) => {
                    if (!hasAnyOrganic(data)) return true;
                    return !!value;
                }, "Required")
                .addRule((value, data) => {
                    if (!hasAnyOrganic(data) || !value) return true;
                    return ipRegex.test(String(value));
                }, "Please enter legal IP Address"),

            organic_port: NumberType()
                .addRule((value, data) => {
                    if (!hasAnyOrganic(data)) return true;
                    return value !== undefined && value !== null && value !== "";
                }, "Required")
                .addRule((value, data) => {
                    if (!hasAnyOrganic(data)) return true;
                    const n = Number(value);
                    return Number.isFinite(n) && n >= 0 && n <= 65535;
                }, "Enter the correct port"),

            organic_login: StringType()
                .addRule((value, data) => !hasAnyOrganic(data) || !!value, "Required")
                .addRule((value, data) => {
                    if (!hasAnyOrganic(data) || !value) return true;
                    const len = String(value).length;
                    return len >= 4 && len <= 16;
                }, "System ID length must be 4-16"),

            organic_password: StringType()
                .addRule((value, data) => !hasAnyOrganic(data) || !!value, "Required")
                .addRule((value, data) => {
                    if (!hasAnyOrganic(data) || !value) return true;
                    const len = String(value).length;
                    return len >= 4 && len <= 9;
                }, "Password length must be 4-9"),
        });
    }, [organicState]);

    useEffect(() => {
        const allFieldsAreEmpty = !organicState.organic_ip && !organicState.organic_port && !organicState.organic_login && !organicState.organic_password;
        const anyCheckboxEnabled = !!organicState.organic_use_ssl || !!organicState.pass_all_traffic_to_organic;
        if (allFieldsAreEmpty && anyCheckboxEnabled) {
            setOrganicState((prev) => ({ ...prev, organic_use_ssl: false, pass_all_traffic_to_organic: false }));
        }
    }, [organicState.organic_ip, organicState.organic_port, organicState.organic_login, organicState.organic_password, organicState.organic_use_ssl, organicState.pass_all_traffic_to_organic]);

    const isNonDialerOganicDisabled = formState?.bill_only_delivered || false;

    return (
        <Form
            layout={isMobile ? null : "inline"}
            model={formSmsSupplierModel}
            formDefaultValue={defaultFormValue}
            formValue={formState}
            onChange={(formValue) => {
                setFormState(formValue);
            }}
            ref={updateFormRef}
            style={{ margin: 0, width: "100%" }}
        >
            <StyledFlexboxGrid ml={40} justify="start">
                <FlexboxGrid.Item>
                    <CustomField
                        inline={!isMobile}
                        block
                        width={300}
                        accepter={Input}
                        label="Trunk name"
                        placeholder="Name..."
                        name="name"
                        classPrefix={"rs-form-control"}
                    />
                </FlexboxGrid.Item>

                <FlexboxGrid.Item className={"ml-2"}>
                    <CheckboxControl
                        name="active"
                        defaultChecked={defaultFormValue.active}
                    >
                        Active
                    </CheckboxControl>
                </FlexboxGrid.Item>
                {isTransitTrunks ? <FlexboxGrid.Item className={"ml-2"}>
                    <Whisper
                        trigger="active"
                        speaker={<Tooltip>If this option enabled, the traffic will come only through prefixes and won"t come by mcc/mnc codes.</Tooltip>}
                        placement="auto"
                    >
                        <CheckboxControl
                            name="custom_ranges"
                            defaultChecked={defaultFormValue.custom_ranges}
                            disabled={!newTrunk}
                        >
                            Custom ranges trunk
                        </CheckboxControl>
                    </Whisper>
                </FlexboxGrid.Item> : <></>}
            </StyledFlexboxGrid>

            <StyledTwoColumnLayout mb={10}>
                <StyledLeftColumn>
                    <StyledFlexboxGrid ml={40} mt={10} justify="start">
                        <FlexboxGrid.Item>
                            <CustomField
                                inline={!isMobile}
                                style={{ minWidth: 160 }}
                                width={200}
                                accepter={SelectPicker}
                                data={[
                                    { key: "smpp", name: "SMPP" },
                                    { key: "http/https", name: "HTTP" },
                                    { key: "smpp_mo", name: "SMPP (MO)" },
                                ]}
                                labelKey="name"
                                valueKey="key"
                                name="message_protocol"
                                onChange={(key) => {
                                    setProtocolType(key);
                                }}
                                searchable={false}
                                cleanable={false}
                                label="Protocol type"
                            />
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>

                    {isOneOfSmpp && <StyledFlexboxGrid ml={40} justify="start">
                        <FlexboxGrid.Item>
                            <CustomField
                                inline={!isMobile}
                                block
                                width={230}
                                data={customRerouteStatusList}
                                accepter={SelectPicker}
                                labelKey="name"
                                valueKey="key"
                                placeholder="Comand status..."
                                name="smpp_reroute_status_key"
                                searchable={false}
                                cleanable={false}
                                classPrefix={"rs-form-control"}
                                virtualized={false}
                                label="SMPP Rerouting Error"
                            />
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>}
                    {isOneOfSmpp && <StyledFlexboxGrid ml={40} justify="start">
                        {protocolTypeValues.smpp && <FlexboxGrid.Item>
                            <CustomField
                                inline={!isMobile}
                                block
                                width={200}
                                data={deliveryDelayTypeData}
                                accepter={SelectPicker}
                                labelKey="name"
                                valueKey="value"
                                placeholder="Type..."
                                name="delivery_delay_type"
                                searchable={false}
                                cleanable={false}
                                classPrefix={"rs-form-control"}
                                virtualized={false}
                                label="Delivery Delay Type"
                            />
                        </FlexboxGrid.Item>}
                        {protocolTypeValues.smpp && <FlexboxGrid.Item className={"ml-2"}>
                            <CustomPercentField
                                inline={!isMobile}
                                block
                                accepter={InputNumber}
                                placeholder="%"
                                name="dlr_percent"
                                cleanable={false}
                                classPrefix={"rs-form-control"}
                                virtualized={false}
                                label="DLR Percent"
                                min={0}
                                max={100}
                                step={1}
                            />
                        </FlexboxGrid.Item>}
                    </StyledFlexboxGrid>}

                    {!protocolTypeValues.http && <StyledFlexboxGrid ml={40} justify="start">
                        <FlexboxGrid.Item>
                            <CustomField
                                inline={!isMobile}
                                block
                                accepter={Input}
                                label="SystemID"
                                placeholder="System ID..."
                                name="systemid"
                                classPrefix={"rs-form-control"}
                            />
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item className={"ml-2"}>
                            <CustomField
                                inline={!isMobile}
                                block
                                accepter={Input}
                                label="Password"
                                placeholder="Password..."
                                name="passwd"
                                classPrefix={"rs-form-control"}
                            />
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>}
                    {protocolTypeValues.http && <StyledFlexboxGrid ml={40} justify="start">
                        <FlexboxGrid.Item>
                            <ContentSupplierForm
                                error={error}
                                setError={setError}
                                model={formContentModel}
                                setMoreData={setMoreData}
                                initialValues={initialValues}
                                formatMessage={formatMessage}
                            />
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>}
                </StyledLeftColumn>

                {isOneOfSmpp && <StyledRightColumn>
                    <IpListSection
                        isMobile={isMobile}
                        ipList={ipList}
                        ipFormRef={ipFormRef}
                        formSupplierModel={formSupplierModel}
                        setError={setError}
                        setIpList={setIpList}
                        protocolTypeValues={protocolTypeValues}
                    />
                </StyledRightColumn>}
                {protocolTypeValues.http && <StyledRightColumn>
                    <IpWhiteListSection
                        isMobile={isMobile}
                        httpIpList={httpIpList}
                        setHttpIpList={setHttpIpList}
                        setError={setError}
                    />
                </StyledRightColumn>}
            </StyledTwoColumnLayout>

            {isTransitTrunks && protocolTypeValues.smpp && <StyledFlexboxGrid ml={40} mb={20}>
                <StyledSingleLineFlexboxGridItem width={220}>
                    <span className="title">Non dialer traffic route
                        {initialValues?.organic_bound ? <Whisper
                            speaker={<Tooltip>Bound</Tooltip>}
                            trigger="hover"
                        >
                            <Icon icon="link" style={{ marginLeft: "5px" }} />
                        </Whisper> : <></>}
                    </span>

                    <NonDialerTrafficRoute
                        model={nonDialerTrafficRouteModel}
                        error={error}
                        disabled={disabled || isNonDialerOganicDisabled}
                        formRef={updateFormRef4}
                        organicState={organicState}
                        formDefaultValue={initialValues}
                        setError={setError}
                        onFilledOrEmpty={setNonDialerPartial}
                        onValidityChange={setNonDialerValid}
                        setOrganicState={setOrganicState}
                    />
                </StyledSingleLineFlexboxGridItem>
            </StyledFlexboxGrid>}

            <StyledTwoColumnLayout mb={0}>
                <StyledLeftColumn>
                    {isOneOfSmpp && <StyledFlexboxGrid justify="start" ml={30} mt={0} mb={0}>
                        <FlexboxGrid.Item className={"mb-1"}>
                            <CheckboxControl
                                name="bill_only_delivered"
                                defaultChecked={defaultFormValue.bill_only_delivered}
                                disabled={isBillOnlyDeliveredDisabled}
                            >
                                Bill only delivered SMS
                            </CheckboxControl>
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>}
                    <StyledFlexboxGrid justify="start" ml={30} mt={0} mb={0}>
                        <FlexboxGrid.Item className={"mb-1"}>
                            <CheckboxControl
                                name="tariffication_all"
                                defaultChecked={defaultFormValue.tariffication_all}
                            >
                                Bill all traffic
                            </CheckboxControl>
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>
                    {isOneOfSmpp && <StyledFlexboxGrid justify="start" ml={30} mt={0} mb={0}>
                        <FlexboxGrid.Item className={"mb-1"}>
                            <CheckboxControl
                                name="block_traffic_limit_excess"
                                defaultChecked={defaultFormValue.block_traffic_limit_excess || false}
                            >
                                Block traffic after limits exceed
                            </CheckboxControl>
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid>}

                    {isTransitTrunks ? <StyledFlexboxGrid justify="start" ml={40} mt={10} mb={10}>
                        <FlexboxGrid.Item>
                            <CustomField
                                inline={!isMobile}
                                block
                                width={250}
                                accepter={SelectPicker}
                                data={supplierPriceList}
                                renderMenuItem={renderMenuItem}
                                valueKey="id"
                                labelKey="name"
                                label="Price"
                                placeholder="Price..."
                                name="supplier_price_id"
                                classPrefix={"rs-form-control"}
                            />
                        </FlexboxGrid.Item>
                    </StyledFlexboxGrid> : <StyledFlexboxGrid justify="start" ml={40} mt={10} mb={10}>
                        {paymentTermsList.map((term, idx) => {
                            return <FlexboxGrid.Item key={term.name} className={idx > 0 ? "ml-2" : ""}>
                                <CustomField
                                    block
                                    width={120}
                                    accepter={InputNumber}
                                    label={`Discount for ${term.name}:`}
                                    name={`discount_${term.name}`}
                                    placeholder="Discount"
                                />
                            </FlexboxGrid.Item>;
                        })}
                    </StyledFlexboxGrid>}

                </StyledLeftColumn>
                <StyledRightColumn>
                    <TrafficLimitSection
                        isMobile={isMobile}
                        isTransitTrunks={isTransitTrunks}
                        trafficLimitKeyList={trafficLimitKeyList}
                        trafficLimitEditData={trafficLimitEditData}
                        initTrafficLimitList={initTrafficLimitList}
                        formTrafficLimitRef={formTrafficLimitRef}
                        trafficLimitModel={trafficLimitModel}
                        setError={setError}
                        setTrafficLimitKeyList={setTrafficLimitKeyList}
                        setTrafficLimitEditData={setTrafficLimitEditData}
                        acceptedTrafficLimitList={acceptedTrafficLimitList}
                        setAcceptedTrafficLimitList={setAcceptedTrafficLimitList}
                    />
                </StyledRightColumn>
            </StyledTwoColumnLayout>

            <>
                <Header ml={40} mt={20} mb={10}>Comments viewed in access lists</Header>

                <StyledFlexboxGrid justify="start" ml={40} mt={10} mb={10}>
                    <FlexboxGrid.Item>
                        <CustomField
                            inline={!isMobile}
                            block
                            width={500}
                            accepter={Input}
                            label="Internal"
                            placeholder="Comment..."
                            name="comment_admin"
                            classPrefix={"rs-form-control"}
                        />
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item className={"ml-2"}>
                        <CustomField
                            inline={!isMobile}
                            block
                            width={500}
                            accepter={Input}
                            label="For dialers"
                            placeholder="Comment..."
                            name="comment_dialer"
                            classPrefix={"rs-form-control"}
                        />
                    </FlexboxGrid.Item>
                </StyledFlexboxGrid>
            </>
        </Form>
    );
};

const mapState = ({ references }) => ({
    defaultSPKey: references.defaultSPKey
});

export default connect(mapState, null)(withTranslation(TrunkFormRefactored));
